export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8784.0970dd75.jpg";